@if (!langLoaded) {
  <div class="spinner-overlay">
    <mat-spinner> </mat-spinner>
  </div>
}

@if (langLoaded) {
  <div style="height: 100vh;">
    <router-outlet></router-outlet>
    <app-help-assistant></app-help-assistant>
  </div>
}
